'use strict';

function PriceRecommendationServicesAnalysisGridPanelDirective() {
  return {
    restrict: 'E',
    template: require('../templates/price-recommendation-services-analysis-grid-panel.html'),
    replace: true,
    controller: 'PriceRecommendationServicesAnalysisGridController',
    scope: {},
    link: function link(scope) {
      scope.$on('chart:services:selectedService', function (evt, originalService) {
        scope.directionFilter = 'both';
        scope.retrieveData(originalService, scope.$parent.snapshotDate);
      });
    }
  };
}
PriceRecommendationServicesAnalysisGridPanelDirective.$inject = [];
module.exports = PriceRecommendationServicesAnalysisGridPanelDirective;